<div class="row ">
  <div style="margin-bottom: 6px; width: 99%">
    <page-alert
      *ngIf="submittedHours && successSubmited"
      message="Solcitação de mudança enviada com sucesso!"
      alertClass="alert-success"
    ></page-alert>
    <page-alert *ngIf="submittedHours && !successSubmited" message="Falha ao enviar solicitação!" alertClass="alert-danger"></page-alert>
  </div>

   <h2>Defina seu horário de trabalho</h2>
  <form [formGroup]="horariosForm" class="form-group" (ngSubmit)="onSubmit()">
   
    <mat-card *ngFor="let dia of diasSemana" [formGroupName]="dia">
      <div class="col-xs-12 col-md-2">
        <mat-checkbox formControlName="active"> {{ dia }} </mat-checkbox>
      </div>
      <div class="col-xs-12 col-md-10" formArrayName="hours">
        <div *ngFor="let hour of getHoursArray(dia)?.controls; let i = index" [formGroupName]="i" class="row">
          <div class="col-xs-12 col-sm-4">
            <mat-form-field appearance="outline">
              <mat-label> Horário de início - Expediente:</mat-label>
              <input matInput type="time" formControlName="startHour" class="form-control" />
            </mat-form-field>
          </div>
          <div class="col-xs-12 col-sm-4">
            <mat-form-field appearance="outline">
              <mat-label>Horário de término - Expediente:</mat-label>
              <input matInput type="time" formControlName="endHour" class="form-control" />
            </mat-form-field>
          </div>
          <div class="col-xs-12 col-sm-4" style="margin-top: 10px">
            <button type="button" mat-raised-button color="warn" class="btRemover" (click)="removeHour(dia, i)">Remover</button>
          </div>
        </div>
        <div class="col-xs-12 col-md-12">
          <button type="button" mat-raised-button color="primary" class="btAddHorario" (click)="addHour(dia)">Adicionar horário</button>
        </div>
      </div>
    </mat-card>
    <div class="col-xs-12 row align-right">
      <button mat-button color="primary" [mat-dialog-close]="true">Fechar</button>
      <button class="button" mat-button type="submit" mat-raised-button color="primary" *ngIf="canEdit" [disabled]="horariosForm.invalid">
        Solicitar mudança
      </button>

    </div>
  </form>
</div>
